import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import SalaryClass from '../../../../components/modules/hr/salary-class';
import SalaryClassMiddleware from '../../../../middleware/modules/hr/salary-class';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,salaryClass }) => ({
  isProcessing: salaryClass.isProcessing,
  isError: salaryClass.isError,
  errorMessage: salaryClass.errorMessage,
  datalist:salaryClass.data,
  showModal:salaryClass.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>SalaryClassMiddleware.getHelper(),
    create: () =>SalaryClassMiddleware.create(),
    reset: () =>SalaryClassMiddleware.resetList(),
    search: data =>SalaryClassMiddleware.list(data),
    update: data =>SalaryClassMiddleware.update(data),
    view:(data)=>SalaryClassMiddleware.beforeView(data),
    delete: (id,search) =>SalaryClassMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class SalaryClassContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.getHelper()
    this.props.update(id)
  }
  createItem(){
    this.props.getHelper()
    this.props.create()
  }
  render() {
    const {datalist} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Salary Class List")}
          </title>
        </Helmet>
      <SalaryClass
        {...this.props}
        data={datalist}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalaryClassContainer);
